import "core-js/modules/es.error.cause.js";
import MyDialog from '@/components/Dialog/Dialog';
import { changeCurrentUserPassword } from '@/api/sys/user';
export default {
  name: 'ChangePassword',
  components: {
    MyDialog: MyDialog
  },
  data: function data() {
    var _this = this;
    var validPass = function validPass(rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== _this.form.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      visible: false,
      form: {
        // 修改密码
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        oldPassword: [{
          required: true,
          message: '旧密码不能为空',
          trigger: 'blur'
        }],
        newPassword: [{
          required: true,
          message: '新密码不能为空',
          trigger: 'blur'
        }],
        confirmPassword: [{
          validator: validPass,
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    handleShow: function handleShow() {
      this.visible = true;
    },
    handleSubmit: function handleSubmit() {
      var _this2 = this;
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          changeCurrentUserPassword(_this2.form).then(function () {
            _this2.$notify({
              title: '成功',
              message: '修改密码成功.',
              type: 'success',
              duration: 2000
            });
            _this2.visible = false;
          });
        }
      });
    }
  }
};